var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditActionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.23577 17.7216C0.966937 17.7211 0.710665 17.6077 0.529474 17.4091C0.344943 17.2122 0.253249 16.9458 0.277433 16.677L0.512224 14.0952L11.3586 3.25265L14.7483 6.64131L3.90472 17.4829L1.32297 17.7177C1.29327 17.7206 1.26356 17.7216 1.23577 17.7216ZM15.4248 5.96377L12.0362 2.5751L14.0688 0.54248C14.2486 0.362527 14.4925 0.261414 14.7468 0.261414C15.0012 0.261414 15.2451 0.362527 15.4248 0.54248L17.4575 2.5751C17.6374 2.75486 17.7385 2.99878 17.7385 3.25313C17.7385 3.50748 17.6374 3.75139 17.4575 3.93115L15.4258 5.96281L15.4248 5.96377Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditActionIcon);
export default __webpack_public_path__ + "static/media/edit-action-icon.0d69edd5afd93c9692abed51f661e842.svg";
export { ForwardRef as ReactComponent };